import React, {useContext, useEffect, useState} from "react";
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Button from "@material-ui/core/Button";
import {ListItemIcon, Menu, MenuItem, Paper} from "@material-ui/core";
import {Edit, HighlightOff, Undo} from "@material-ui/icons";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import RenderComponents from "../RenderByType/RenderComponents";
import {useDrop} from "react-dnd";
import {AcceptTypes} from "../../../ToolBar/ToolBarUtils/ItemTypes";
import Divider from "@material-ui/core/Divider";
import {primaryDropColor} from "../../ScreenBar";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../../JsonScreen/Utils/lib";
import {uid} from "react-uid";
import FileCopyIcon from "@material-ui/icons/FileCopy";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    stepButtonRoot: {
        padding: '4px 16px'
    },
    nextButton: {
        margin: '8px 8px',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },

    contextPaper: {
        paddingTop: 0,
        paddingBottom: 0
    },
    menuItemRoot: {
        color: '#676767',
        '&:hover': {
            color: '#000000'
        }
    },
    listIconRoot: {
        minWidth: 30
    }
}));
const stepSource = {
    type: 'step',
    properties: {label: 'New Step'},
    children: []
};
const additionalAreaSource = {
    type: 'stepperAdditionalArea',
    children: []
}
const initialContextState = {
    mouseX: null,
    mouseY: null,
};
const StepperComponent = (props) => {
    const {
        onDeleteComponent,
        onSelectComponent,
        onDropComponent
    } = useContext(ScreenDesignerContextNew);
    const {component: {children = []}, path} = props;
    const [steps, setSteps] = useState([]);
    const [additionalArea, setAdditionalArea] = useState({source: {children: []}, sourceIndex: 0})
    const [activeStep, setActiveStep] = React.useState(0);
    const [anchorEl, setAnchorEl] = useState(initialContextState);
    const [editStep, setEditStep] = useState({index: null, source: null});
    const {userLanguage} = useSelector(state => state.app);
    const classes = useStyles();

    useEffect(() => {
        if (children && children.length) {
            const steps = children.map((item, i) => {
                if (item.type === 'step') {
                    return {
                        source: {properties: {}, ...item},
                        index: i
                    }
                }
            }).filter(s => Boolean(s))

            const additionalAreaIndex = children.findIndex(ch => ch.type === 'stepperAdditionalArea');
            setSteps(steps)
            if (additionalAreaIndex === -1) {
                //onDropComponent(additionalAreaSource, 0, `${path}.children.${children.length}`)
                setAdditionalArea({
                    source: additionalAreaSource,
                    sourceIndex: -1
                });
                return
            }

            setAdditionalArea({
                source: children[additionalAreaIndex],
                sourceIndex: additionalAreaIndex
            });

            return;
        }
        setAdditionalArea({source: additionalAreaSource, sourceIndex: 0})
        setSteps([]);

    }, [JSON.stringify(children)])

    function closeTabContext() {
        setAnchorEl(initialContextState);
        setEditStep({index: null, source: null})
    }

    function onEditStep() {
        onSelectComponent(editStep.source, `${path}.children.${editStep.index}`)
    }

    function onRemoveStep() {
        onDeleteComponent(`${path}.children.${editStep.index}`, editStep.source.type,)
    }

    function addAfter() {
        onDropComponent(stepSource, editStep.index + 1, `${path}.children`)
    }

    function addBefore() {
        onDropComponent(stepSource, editStep.index, `${path}.children`)
    }

    function duplicateStep() {
        onDropComponent(editStep.source, editStep.index + 1, `${path}.children`)
    }

    function handleStep(e, step, item, sourceIndex) {
        onSelectComponent(item, `${path}.children.${sourceIndex}`);
        setActiveStep(step);
        e.stopPropagation();
    }

    function onStepContext(event, source, index) {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl({
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
        });
        setEditStep({index, source})
    }

    return (
        <Paper style={{
            height: '100%',
            width: '100%'
        }}>
            <Stepper activeStep={activeStep} nonLinear>
                {steps.map((step, index) => {
                    const stepProps = {};
                    const buttonProps = {};
                    const multiLanguageLabel = multiLanguageValue(step.source.properties.label, userLanguage)
                    return (
                        <Step key={index} {...stepProps}>
                            <StepButton
                                classes={{root: classes.stepButtonRoot}}
                                onClick={(e) => handleStep(e, index, step.source, step.index)}
                                onContextMenu={(e) => onStepContext(e, step.source, index)}
                                {...buttonProps}
                            >
                                {multiLanguageLabel}
                            </StepButton>
                        </Step>
                    )
                })}
            </Stepper>
            <Divider/>
            <div style={{margin: 2, height: 'calc(100% - 123px)', overflow: 'auto'}}>
                {steps.map((step, index) => {
                    //wrong in source index
                    return (
                        activeStep === index ? (
                            <StepContent
                                step={step.source}
                                activeStep={activeStep}
                                path={`${path}.children.${step.index}`}
                                index={index}
                            />
                        ) : (
                            <></>
                        )
                    )
                })}
            </div>
            <Divider/>
            <div style={{display: 'flex', margin: 2}}>
                <div style={{display: 'flex', flexGrow: 1}}>
                    <Button
                        size={"small"}
                        color={"default"}
                        variant={"contained"}
                        className={classes.nextButton}
                    >
                        Delete
                    </Button>
                    <AdditionalButtonsArea
                        additionalArea={additionalArea}
                        path={path}
                        children={children}
                    />
                </div>
                <Button
                    size={"small"}
                    color={"primary"}
                    variant={"contained"}
                    className={classes.nextButton}
                >
                    Finish
                </Button>

            </div>

            <ContextMenu
                anchorEl={anchorEl}
                onClose={closeTabContext}
                addAfter={addAfter}
                addBefore={addBefore}
                duplicateStep={duplicateStep}
                edit={onEditStep}
                remove={onRemoveStep}
                index={editStep.index}
                stepsCount={steps.length}
            />
        </Paper>
    )
};

export default StepperComponent

StepperComponent.propTypes = {
    component: PropTypes.shape({
        properties: PropTypes.object,
        styles: PropTypes.array,
        children: PropTypes.array
    }),
    path: PropTypes.string
};


const StepContent = ({step: {children = [], styles}, step, activeStep, path, index}) => {
    const {
        onSelectComponent,
        selectedComponent,
        onDropComponent,
        onMoveComponent,
        onDropMultipleComponents
    } = useContext(ScreenDesignerContextNew);

    const isSelected = selectedComponent ? selectedComponent.path === path : false;
    const [{isOverCurrent}, drop] = useDrop({
        accept: AcceptTypes.panel,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
        }),
        drop: (item, monitor) => {
            let newItem = {...item};
            let currentComponent = item.component ? item.component : {};
            let componentChildrenLength = item.component && item.component.children ? item.component.children.length : 0;

            const didDrop = monitor.didDrop();
            if (didDrop) {
                return
            }

            //checking for children, if not, insert item into new panel
            if (item.children && item.type === 'panel') {
                newItem = {
                    ...newItem, children: [{
                        type: 'panel',
                        styles: [{
                            width: "100%",
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }],
                        children: []
                    }]
                }
            }
            if (item.dragType === 'move') {

                //insert panel inside container
                if (item.component.type === 'panel') {
                    currentComponent = {
                        ...item.component, children: [{
                            type: 'panel',
                            styles: [{
                                width: "100%",
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                alignItems: 'flex-start'
                            }],
                            children: item.component.children
                        }]
                    };
                }

                onMoveComponent(currentComponent, item.from, `${path}.children`, children.length);
                return
            }
            if (item.dragType === 'multiple') {
                onDropMultipleComponents(currentComponent, componentChildrenLength, `${path}.children.${index}.children`);
                return
            }

            onDropComponent(newItem, children.length, `${path}.children`)
        }
    });
    const sourceStyles = styles ? styles[0] : {};

    function onClickComponent(e) {
        e.stopPropagation();
        onSelectComponent(step, path)
    }

    return (
        <div ref={drop}
             onClick={onClickComponent}
             style={{
                 height: '100%',
                 width: sourceStyles.width || '100%',
                 padding: sourceStyles.padding,
                 border: `1px dashed ${isSelected || isOverCurrent ? primaryDropColor : 'transparent'}`,
                 display: 'flex',
                 alignItems: 'baseline',
                 flexDirection: 'column',
                 overflow: 'auto'
             }}
        >
            {activeStep === index ? (step.children || []).map((item, i) => {
                return (
                    <RenderComponents
                        key={uid(item)}
                        item={item}
                        type={item.type}
                        parentPath={path}
                        index={i}
                        path={`${path}.children.${i}`}
                    />
                )
            }) : (
                <></>
            )}
        </div>
    )
};

const ContextMenu = ({anchorEl, onClose, addBefore, duplicateStep, addAfter, edit, remove, index, stepsCount}) => {
    const classes = useStyles();
    return (
        <Menu
            classes={{list: classes.contextPaper}}
            open={anchorEl.mouseY !== null}
            anchorReference={"anchorPosition"}
            anchorPosition={
                anchorEl.mouseY !== null && anchorEl.mouseX !== null
                    ? {top: anchorEl.mouseY, left: anchorEl.mouseX}
                    : undefined
            }
            onClose={onClose}
        >
            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    edit();
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <Edit fontSize="small"/>
                </ListItemIcon>
                Edit Step
            </MenuItem>
            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    addBefore();
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <Undo fontSize="small"/>
                </ListItemIcon>
                Add Before
            </MenuItem>
            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    addAfter();
                    // duplicateItem(`${parentPath}.children`, item, index);
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <Undo fontSize="small" style={{transform: 'rotate(180deg)'}}/>
                </ListItemIcon>
                Add After
            </MenuItem>
            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    duplicateStep();
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <FileCopyIcon fontSize="small"/>
                </ListItemIcon>
                Duplicate
            </MenuItem>
            <MenuItem
                dense
                disabled={stepsCount === 1 && index === stepsCount - 1}
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    remove();
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <HighlightOff fontSize="small"/>
                </ListItemIcon>
                Remove
            </MenuItem>
        </Menu>
    )
};

const AdditionalButtonsArea = ({path, additionalArea}) => {
    const {
        onDropComponent,
        onMoveComponent,
    } = useContext(ScreenDesignerContextNew);

    const {sourceIndex, source: {children}} = additionalArea;

    //const isSelected = selectedComponent ? selectedComponent.path === path : false;

    const [{isOverCurrent}, drop] = useDrop({
        accept: AcceptTypes.panel,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
        }),
        drop: (item, monitor) => {
            let newItem = sourceIndex === -1 ? {...additionalAreaSource, children: [item]} : item;
            const pathToDrop = sourceIndex === -1 ? `${path}.children` : `${path}.children.${sourceIndex}.children`
            let currentComponent = item.component ? item.component : {};

            const didDrop = monitor.didDrop();
            if (didDrop) {
                return
            }

            //checking for children, if not, insert item into new panel
            if (item.children && item.type === 'panel') {
                return
            }
            if (item.dragType === 'move') {

                //insert panel inside container
                if (item.component.type === 'panel') {
                    currentComponent = {
                        ...item.component, children: [{
                            type: 'panel',
                            styles: [{
                                width: "100%",
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                alignItems: 'flex-start'
                            }],
                            children: item.component.children
                        }]
                    };
                }

                onMoveComponent(currentComponent, item.from, pathToDrop, children.length);
                return
            }
            if (item.dragType === 'multiple') {
                //onDropMultipleComponents(currentComponent, componentChildrenLength, `${path}.children.${index}.children`);
                return
            }

            onDropComponent(newItem, children.length, pathToDrop)
        }
    });
    return (
        <div style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            border: `1px dashed ${isOverCurrent ? primaryDropColor : 'transparent'}`,
        }} ref={drop}>
            {children.map((item, i) => {
                return (
                    <RenderComponents
                        key={uid(item)}
                        item={item}
                        type={item.type}
                        parentPath={`${path}.children.${sourceIndex}`}
                        index={i}
                        path={`${path}.children.${sourceIndex}.children.${i}`}
                    />
                )
            })}
        </div>
    )
}